<template>
  <div id="app">
    <router-view/>
  </div>

  <ModalVideoChamada/>
  <TourNotificacoesOverlay/>

</template>
<script>

import ModalVideoChamada from '../src/views/pages/Mensagens/ModalVideoChamada';
import TourNotificacoesOverlay from './components/TourNotificacoesOverlay.vue';

export default {
  name: 'App',
  components: { ModalVideoChamada, TourNotificacoesOverlay },
  data: function () {
    return {status: false}
  },
}
</script>


